import { Segmented } from 'antd';
import { useMemo, useState } from 'react';
import { getFromStorage, storeInLocal } from 'src/lib/storage';
import EhrOnboardingCard from './EhrOnboardingCard';
import {
  EHR_ONBOARDING_REGISTRY,
  getEhrOnboardingEntry,
} from './ehrOnboardingRegistry';

const STORAGE_KEY = 'ehrOnboardingActiveEhr';

// Top-level "EHR Onboarding" panel inside the SuperAdmin -> EHR Integrations
// page. Renders a sub-segment per registered EHR; the actual onboarding
// form is the generic <EhrOnboardingCard /> driven by the registry entry.
const OnboardingPage = () => {
  const segmentedOptions = useMemo(
    () =>
      EHR_ONBOARDING_REGISTRY.map((entry) => ({
        label: (
          <span className="flex items-center gap-2">
            {entry.iconUrl && (
              <img
                src={entry.iconUrl}
                alt=""
                className="w-4 h-4 object-contain"
                onError={(e) => {
                  e.currentTarget.style.display = 'none';
                }}
              />
            )}
            {entry.label}
          </span>
        ),
        value: entry.ehrSystem,
      })),
    []
  );

  const [activeEhr, setActiveEhr] = useState(() => {
    const stored = getFromStorage(STORAGE_KEY);
    if (stored && getEhrOnboardingEntry(stored)) return stored;
    return EHR_ONBOARDING_REGISTRY[0]?.ehrSystem;
  });

  const handleChange = (next) => {
    setActiveEhr(next);
    storeInLocal(STORAGE_KEY, next);
  };

  const entry = getEhrOnboardingEntry(activeEhr);

  if (segmentedOptions.length === 0) {
    return (
      <div className="bg-white rounded-lg shadow-sm p-6 text-gray-500">
        No EHR onboarding flows are configured.
      </div>
    );
  }

  return (
    <div className="flex-1 pt-4 flex flex-col gap-4">
      <div className="flex flex-wrap items-center gap-3">
        <Segmented
          options={segmentedOptions}
          value={activeEhr}
          onChange={handleChange}
        />
      </div>
      <EhrOnboardingCard key={entry?.ehrSystem} entry={entry} />
    </div>
  );
};

export default OnboardingPage;
